import { render, staticRenderFns } from "./6-zungui.vue?vue&type=template&id=7c6f643b&scoped=true&"
import script from "./6-zungui.vue?vue&type=script&lang=js&"
export * from "./6-zungui.vue?vue&type=script&lang=js&"
import style0 from "./6-zungui.vue?vue&type=style&index=0&id=7c6f643b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f643b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6f643b')) {
      api.createRecord('7c6f643b', component.options)
    } else {
      api.reload('7c6f643b', component.options)
    }
    module.hot.accept("./6-zungui.vue?vue&type=template&id=7c6f643b&scoped=true&", function () {
      api.rerender('7c6f643b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-zungui.vue"
export default component.exports